/**
 * 防抖函数
 * 传入一个函数、时间
 */

export function debounceFun(func, delay) {
  let t = null;
  return (...args) => {
    if (t) clearTimeout(t)
    t = setTimeout(() => {
      func.call(this, args);
    }, delay)
  }
};